<template>
  <v-dialog
    v-model="display"
    max-width="580"
    content-class="rounded-xl elevation-0"
    @keydown.enter="display = false"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :transition="
      fullscreen ? 'scroll-y-reverse-transition' : 'scale-transition'
    "
  >
    <v-card elevation="0" rounded="lg" class="nauta-download-modal-card">
      <div class="nauta-download-modal-content">
        <div class="nauta-download-modal-close-container">
          <v-icon color="828282" size="24" @click="display = false">
            mdi-close
          </v-icon>
        </div>
        <div class="nauta-download-modal-container">
          <div class="nauta-download-modal-logos-container">
            <v-img
              :src="require('@/assets/migration/mi-dva-logo-android.png')"
              contain
            />
            <div class="nauta-download-modal-logos-arrow">
              <v-icon color="#232323" :size="$vuetify.breakpoint.xs ? 24 : 30">
                mdi-arrow-right-thin
              </v-icon>
            </div>
            <v-img
              :src="require('@/assets/migration/nauta-logo-android.png')"
              contain
            />
          </div>
          <h3 class="nauta-download-modal-title">
            {{ $t("nautaMigration.downloadModal.title") }}
          </h3>
          <div class="nauta-download-modal-qr-container">
            <v-img
              contain
              :src="require('@/assets/migration/nauta-download-qr.png')"
            />
          </div>
          <div class="nauta-download-modal-download-here">
            {{ $t("nautaMigration.downloadModal.downloadHere") }}
          </div>
          <div class="nauta-download-modal-button-row">
            <div class="nauta-download-modal-button">
              <NewButton
                :text="$t('nautaMigration.downloadModal.apple')"
                icon="mdi-apple"
                link="https://apps.apple.com/cl/app/nauta/id6744368351"
                iconSize="24"
              />
            </div>
            <div class="nauta-download-modal-button">
              <NewButton
                :text="$t('nautaMigration.downloadModal.google')"
                link="https://play.google.com/store/apps/details?id=com.dvacapital.nauta&pcampaignid=web_share"
                icon="mdi-google-play"
                iconSize="24"
              />
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";

export default {
  name: "NautaDownloadModal",

  components: { NewButton },

  props: {
    value: Boolean,
    title: String,
    fullscreen: Boolean,
    persistent: Boolean,
  },

  computed: {
    display: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("display", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.nauta-download-modal-content {
  height: 100%;
  padding: 32px;
  @media (max-width: 600px) {
    padding: 10px;
  }
}

.nauta-download-modal-close-container {
  display: flex;
  justify-content: flex-end;
}

.nauta-download-modal-title {
  font-size: 28px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
  text-align: center;
  color: #333333;
  margin: 24px 0;

  @media (max-width: 600px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.4px;
    margin: 16px 0;
  }
}

.nauta-download-modal-download-here {
  color: #646363;
  text-align: center;
  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  margin: 24px 0;

  @media (max-width: 600px) {
    font-size: 14px;
    margin: 16px 0;
  }
}
.nauta-download-modal-download-here-container {
  @media (max-width: 600px) {
    margin: 20px;
  }
}

.nauta-download-modal-logos-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 8px;
  margin-top: 32px;
}

.nauta-download-modal-logos-container > * {
  width: 64px;
  height: 64px;
  max-width: 64px !important;

  @media (max-width: 600px) {
    width: 40px;
    height: 40px;
    max-width: 40px !important;
  }
}

.nauta-download-modal-logos-arrow {
  background-color: #ede8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 36px;
  width: 36px;

  @media (max-width: 600px) {
    width: 17.143px;
    height: 17.143px;
  }
}

.nauta-download-modal-button-row {
  display: flex;
  gap: 10px 8px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
}

.nauta-download-modal-button-row > * {
  width: 100% !important;
}

.nauta-download-modal-button ::v-deep .new-btn {
  height: 56px !important;
}

.nauta-download-modal-qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nauta-download-modal-qr-container > * {
  width: 220;
  height: 220px;
}

.nauta-download-modal-container {
  padding: 24px;
}
</style>
